import BreadCurmb from 'components/BreadCrumbMex/BreadCrumb';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import Page from 'components/Page';
import { ambienteAplicacion } from 'constants/urls';
import { useNavbarContext } from 'contexts/NavbarContext';
import useCustomToast from 'hooks/useCustomToasts';
import React, { useCallback, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import Loading from 'wrappers/Loading';
import { DO } from './constantes/general';
import { DatosAsegurado } from './formas/DatosAsegurado';
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import { URLS_PHP_7 } from 'constants/urls_v2';

export const DODatosAsegurado = ({
    dataUsuario: { cliCodigoCore },
    qParams: { idCotizacion },
    history
}) => {
    useNavbarContext(PRODUCTOS.CYBER);
    const [loading, setLoading] = useState(false);
    const [catalogo, setCatalogo] = useState({});
    const [profesiones, setProfesiones] = useState([]);
    const [moneda, setMoneda] = useState({});
    const { addWarningToast } = useCustomToast();
    const methods = useForm({ mode: 'onChange' });
    const { handleSubmit, reset } = methods;
    const [loadingSumas, setLoadingSumas] = useState(false);
    const [bloquearContinuar, setBloquearContinuar] = useState(false)
    const [sumasAseguradas, setSumasAseguradas] = useState([]);
    const [showSumas, setShowSumas] = useState(false);

    const sumaAsegurada = methods.watch('datosCotizacion.sumaAsegurada');

    useEffect(() => {


        if (sumaAsegurada && sumasAseguradas?.length === 0) {
            calcularSumasAseguradas(true);
            // reset({ ...loadValues })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sumaAsegurada])

    const format = (number) => {
        return new Intl.NumberFormat('en-us', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(number);
    };
    const onSubmit = async (data) => {
        setLoading(true);

        const { giroSeleccionado, ...rest } = data?.datosCotizacion
        const Data = {
            ambiente: ambienteAplicacion,
            prodCodigo: DO.prodCodigoCore,
            pasoCodigo: 'informacionCliente',
            items: {
                cotCodigo: idCotizacion || '',
                datosCliente: data.datosCliente,
                usuCotiza: { usuCodigo: cliCodigoCore || '' },
                agente: data?.agente,
                datosCotizacion: {
                    ...rest,
                    moneda: moneda?.codigo || "1",
                    giroSeleccionado,
                    giro: giroSeleccionado?.giro?.toString(),
                    idGiro: giroSeleccionado?.id?.toString(),
                    giroSic: giroSeleccionado?.giroSic || 999,
                },
            },
        };


        let res = await ApiKeyFetch.instance().post(URLS_PHP_7.cotizacion.actualizarCotizacion, Data);

        console.log(Data, res);
        if (res.transaccion && res.id) {
            history.push(
                `${DO.urls.preguntas}?idCotizacion=${res.id}`,
            );

        } else {
            reset({ ...data });
            try {
                if (res?.errorDescripcion?.mensajeValidacion) {
                    addWarningToast(res?.errorDescripcion?.mensajeValidacion, { autoDismiss: false })
                } else {
                    if (typeof res.errorDescripcion === 'string') {
                        addWarningToast(res.errorDescripcion, { autoDismiss: false });
                    } else {
                        res.errorDescripcion.forEach((msg) =>
                            addWarningToast(msg, { autoDismiss: false }),
                        );
                    }
                }
            } catch (e) {
                addWarningToast('Error desconocido', { autoDismiss: false });
            }
        }
        setLoading(false);
    };

    const loadData = useCallback(
        async () => {
            setLoading(true);
            const DataResumen = {
                cotDatos: {
                    ambiente: ambienteAplicacion,
                    cotCodigo: idCotizacion,
                },
            };
            try {
                let resResumen = await ApiKeyFetch.instance().post(
                    URLS_PHP_7.cotizacion.resumenCotizacion,
                    DataResumen,
                );
                reset({
                    datosCotizacion: {
                        ...resResumen?.cotConsulta?.prodDatos[0]
                    },
                    datosCliente: {
                        ...resResumen?.cotConsulta?.carContratante
                    }
                });


            } catch (error) {

            }
            setLoading(false);
        },
        [idCotizacion, reset],
    )


    const onSubmitError = (errors) => { };
    const getData = useCallback(async () => {
        setLoading(true);
        const Data = {
            datosCotizador: {
                prodCodigo: DO.prodCodigoCore,
                catPasoCodigo: 'validaciones',
                usuCotiza: {
                    usuCodigo: cliCodigoCore,
                },
            },
        };
        try {
            const resp = await ApiKeyFetch.instance().post(URLS_PHP_7.cotizacion.catalogosCotizador, Data);
            console.log(resp);
            if (resp?.transaccion && resp.catalogo) {
                setCatalogo(resp.catalogo);
                setProfesiones(resp?.catalogo?.profesiones?.map(prof => { return ({ label: prof?.texto, value: prof }) }));
                setMoneda(resp?.catalogo?.monedas?.map(mon => ({ label: mon?.texto, value: mon?.codigo?.toString() }))?.[0]);
            }
        } catch (error) { }
        if (idCotizacion) {
            loadData();
            return;
        }
        setLoading(false);
    }, [cliCodigoCore, loadData, idCotizacion]);

    useEffect(() => {
        getData();
    }, [getData]);

    const calcularSumasAseguradas = useCallback(async (initLoad = false) => {
        let values = { ...methods.getValues() };
        let existeSuma = true;
        setBloquearContinuar(true);
        if (methods.watch('datosCotizacion.giroSeleccionado') &&
            Number(methods.watch('datosCotizacion.ingresoAnualBruto')) > 0) {
            setShowSumas(true);
            setLoadingSumas(true);
            // setLoading(true);
            const Data = {
                datosCotizador: {
                    prodCodigo: DO.prodCodigoCore,
                    catPasoCodigo: "sumaAsegurada",
                    ingresoAnualBruto: Number(methods.watch('datosCotizacion.ingresoAnualBruto')),
                    codGiro: methods.watch('datosCotizacion.giroSeleccionado')?.giro?.toString(),
                    idGiro: methods.watch('datosCotizacion.giroSeleccionado')?.id?.toString(),
                    moneda:moneda?.codigo||'1'
                },
            };
            try {
                const resp = await ApiKeyFetch.instance().post(URLS_PHP_7.cotizacion.catalogosCotizador, Data);
                console.log(resp, values);
                if (resp?.transaccion && resp?.catalogo) {
                    let sumas=resp?.catalogo?.sumasAseguradas?.map(sum => ({ label: `${format(sum)}`, value: sum }));
                    setSumasAseguradas(sumas);
                    if (resp?.catalogo?.sumasAseguradas?.filter(sum => sum === values?.datosCotizacion?.sumaAsegurada).length === 0) {
                        existeSuma = false
                    }
                    setBloquearContinuar(false);
                } else {
                    try {
                        setSumasAseguradas([]);
                        if (Array.isArray(resp.errorDescripcion)) {
                            resp.errorDescripcion.forEach((msg) =>
                                addWarningToast(msg?.mensaje, { autoDismiss: false }),
                            );
                        } else {
                            const keys = Object.keys(resp.errorDescripcion);
                            keys.forEach((key) =>
                                addWarningToast(resp.errorDescripcion[key], { autoDismiss: false }),
                            );
                        }
                    } catch (e) {
                        addWarningToast('Error desconocido', { autoDismiss: false });
                    }
                    setBloquearContinuar(true);
                }
            } catch (error) { }
            setLoadingSumas(false);
            if (!initLoad) {
                if (!existeSuma) {
                    values.datosCotizacion.sumaAsegurada = null;
                }
                methods.reset({ ...values });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Loading loading={loading}>
            <div className="cr-content">
                <Page>
                    <BreadCurmb
                        {...PASOS_BREADCRUMBS[PRODUCTOS.DO].breadCrumb}
                    />

                    <BreadCrumbPasosV2
                        {...PASOS_BREADCRUMBS[PRODUCTOS.DO]
                            .breadCrumbPasosCotizacion[1]}
                        styleimg="height200px mr-3"
                        pasos={PASOS_BREADCRUMBS[PRODUCTOS.DO]?.pasosCotizacion}
                    />

                    <FormProvider {...methods}>
                        <form onSubmit={handleSubmit(onSubmit, onSubmitError)}>
                            <DatosAsegurado
                                catalogo={catalogo}
                                showSumas={showSumas}
                                clavesAgente={catalogo?.permisos?.agentes}
                                onSubmitError={onSubmitError}
                                profesiones={profesiones}
                                cargarSumasAseguradas={calcularSumasAseguradas}
                                sumasAseguradas={sumasAseguradas}
                                bloqueo={bloquearContinuar}
                                loadingSumas={loadingSumas}
                            />
                        </form>
                    </FormProvider>
                </Page>
            </div>
        </Loading>
    );
};
